import { Component, inject, OnInit } from '@angular/core';
import { LoginService } from './shared/services/login.service';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus } from "@azure/msal-browser";
import { filter } from "rxjs";

import { ScreenPermissionServiceService } from './shared/services/screen-permission-service.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MicrosoftAuthBaseService } from './shared/services/microsoft-auth-base.service';
import { LocalStorageSettingsService } from './shared/services/local-storage-settings.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit{
    private vaultSessionId: string | null = null;
  private messageHandler = this.onMessage.bind(this);
  title = 'target';
   private readonly VAULT_TIMEOUT_MS = 3000; // tweak if needed
  private startupResolved = false;
    bootReady = false;
    pathName=""
  constructor(private microsoftAuthService: MicrosoftAuthBaseService, private spinner: NgxUiLoaderService,
    private loginService: LoginService,private localStorageSettings: LocalStorageSettingsService){

  }
 
  async ngOnInit() {
      this.pathName = window.location.pathname;

  window.addEventListener(
    'message',
    this.messageHandler
  );

  this.sendVaultReady();

  try {
    const microsoftUsername =
      await this.microsoftAuthService.initialize();
      console.log("microsoftUsername",microsoftUsername);
      console.log("msalUser",JSON.parse(this.localStorageSettings.getSettings("msalUser")));

    if (microsoftUsername) {
        const msalUser=JSON.parse(this.localStorageSettings.getSettings("msalUser"));
      if(!msalUser){
        this.getJWTforMicrosoftLogin(
        microsoftUsername
      );
      }
    }
  } catch (error) {
    console.error(
      'Microsoft authentication initialization failed:',
      error
    );
  }
}
  getJWTforMicrosoftLogin(username: string): void {
     this.loginService.microsoftLogin(username);
  }

   sendVaultReady(): void {
  // ✅ Only do Vault handshake when embedded in iframe (Vault)
  if (window.self === window.top) {
    console.log('Not in iframe → skipping Vault ready postMessage');
    this.finishStartup(false);
    return;
  }

  const readyMessage = JSON.stringify({ message_id: 'ready', data: {} });

  // ✅ Try to detect actual parent origin from referrer
  const ref = document.referrer;
  if (!ref) {
    console.warn('No referrer → cannot detect Vault origin. Skipping.');
    this.finishStartup(false);
    return;
  }

  const parentOrigin = new URL(ref).origin;

  // ✅ Optional safety: only allow veevavault
  if (!parentOrigin.endsWith('.veevavault.com')) {
    console.warn('Parent is not Vault:', parentOrigin, 'Skipping.');
    this.finishStartup(false);
    return;
  }

  window.parent.postMessage(readyMessage, parentOrigin);
}

 private onMessage(event: MessageEvent): void {
  console.log(event);
  
    // Vault-safe first: strict origin check
    if (event.origin !== environment.vaultOrigins){
       this.finishStartup(false);
      return;
    }

    // Vault sends JSON string
    if (typeof event.data !== 'string'){
       this.finishStartup(false);
      return;
    }

    let msg: any;
    try {
      msg = JSON.parse(event.data);
      console.log('Message from vault', msg);
    } catch {
     this.finishStartup(false);
      return;
    }

    if (msg?.message_id !== 'session_id'){
      this.finishStartup(false);
      return;
    }

    const sessionId = msg?.data?.session_id;
    if (!sessionId){
     this.finishStartup(false);
      return;
    } 

    this.vaultSessionId = sessionId;
    console.log('Received Vault session ID:', sessionId);

    // Avoid duplicate handling
    if (this.startupResolved) return;

    this.exchangeVaultSessionAndTriggerSSO(sessionId);
  }
  exchangeVaultSessionAndTriggerSSO(sessionId: string): void {
    // Use ONE spinner here OR let service manage it.
    // Since generateTokenSSOLogin() starts its own spinner,
    // we use spinner only for getUserBasedOnSessionId().
    this.spinner.start();

    this.loginService.getUserBasedOnSessionId(sessionId).subscribe({
      next: (res: any) => {
        this.spinner.stop();

        if (res?.error === true) {
          this.finishStartup(false);
          return;
        }

        if (res?.data?.responseStatus !== 'SUCCESS') {
          this.finishStartup(false);
          return;
        }

        const username = res?.data?.users?.[0]?.user?.user_name__v;
        if (!username) {
          this.finishStartup(false);
          return;
        }

        // ✅ Important:
        // generateTokenSSOLogin() already navigates to "user" internally.
        // So AppComponent should NOT navigate to /home.
        // Just unlock the UI and let the service route to user.
        this.finishStartup(true);

        // This will start its own spinner + navigateByUrl("user")
        this.loginService.generateTokenSSOLogin(username,this.pathName);
      },
      error: () => {
        this.spinner.stop();
        this.finishStartup(false);
      }
    });
  }
  
 
  finishStartup(isAuthenticated: boolean): void {
    if (this.startupResolved) return;
    this.startupResolved = true;

    // Allow router-outlet to render now (still no flash)
    this.bootReady = true;
  }

}
